import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function WelcomeToCgk() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="38514" id="hero" className="relative min-h-screen w-full overflow-hidden bg-[#1A1A1A] text-white">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[#1A1A1A]/90 z-10 mix-blend-multiply" />
        <div className="absolute inset-0 bg-[#FF006E]/5 z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/hong_kong_cbd_architectural.png" alt="Microvix Dashboard Interface" className="h-full w-full object-cover opacity-40" />
      </div>

      {}
      <div className="pointer-events-none absolute left-0 top-1/4 z-0 w-full select-none overflow-hidden text-center opacity-5" style={{
      transform: `translateY(${scrollY * 0.2}px)`
    }}>
        <span className="block text-[12vw] font-bold leading-none tracking-widest text-transparent" style={{
        WebkitTextStroke: "2px #A0A0A0"
      }}>
          MICROVIX
        </span>
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto flex min-h-screen items-center px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="grid w-full grid-cols-1 lg:grid-cols-12 gap-12">
          {}
          <div className="flex flex-col justify-center space-y-8 lg:col-span-7">
            {}
            <div className="flex items-center gap-4">
              <span className="h-px w-12 bg-[#FF006E]"></span>
              <span className="font-mono text-sm font-medium tracking-widest text-[#FF006E] uppercase">
                ERP Especialista em Varejo
              </span>
            </div>

            {}
            <h1 className="font-sans text-5xl font-bold leading-[1.1] text-white md:text-[60px]">
              IMPULSIONE SEU VAREJO COM{" "}
              <span className="relative inline-block whitespace-nowrap">
                ALTA PERFORMANCE
                <span className="absolute -bottom-2 left-0 h-[3px] w-full bg-[#FF006E]"></span>
              </span>
            </h1>

            {}
            <p className="max-w-xl font-sans text-[20px] font-normal leading-[1.6] text-[#A0A0A0]">
              A solução definitiva para o varejo moderno. Controle total, integração nativa e inteligência de dados para escalar seu negócio com segurança e agilidade.
            </p>

            {}
            <div className="flex flex-wrap items-center gap-5 pt-6">
              <Button asChild className="h-14 rounded-none border-none bg-[#FF006E] px-8 text-base font-bold text-white uppercase shadow-[0_0_20px_rgba(255,0,110,0.3)] transition-transform hover:scale-105 hover:shadow-[0_0_30px_rgba(255,0,110,0.5)]">
                <Link to="/ContactsPage">
                  SOLICITAR DEMONSTRAÇÃO
                </Link>
              </Button>

              <Button asChild variant="ghost" className="h-14 rounded-none border border-white px-8 text-base font-medium text-white transition-colors hover:bg-white hover:text-[#1A1A1A]">
                <Link to="/MicrovixPage">
                  CONHEÇA NOSSAS SOLUÇÕES
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="hidden lg:col-span-5 lg:block">
            {}
          </div>
        </div>
      </div>
    </section>;
}